import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'table-container',
  templateUrl: './table-container.component.html'
})
export class TableContainerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
